import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";

import { Grid, Button, Divider, TextField, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Typography, Box } from '@mui/material';
import FieldView2 from 'core/components/layout/FieldView2';
import PharmaorderEditorderAction from './action/editorder/EditorderAction';
import { setPharmaorderEditorderModal, setPoViewPOModal, setPoUploadPoModal, setPharmaorderSubmitorderModal } from 'store/slice/PharmaSlice';
import PoViewPOAction from 'components/po/action/viewPO/ViewPOAction';
import PoUploadPoAction from 'components/po/action/uploadPo/UploadPoAction';
import SubmitorderAction from './action/submitorder/SubmitorderAction';
import { openDrawer } from '../../store/slice/MenuSlice';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import SelectParty from 'components/party/components/SelectParty';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CloseIcon from '@mui/icons-material/Close';
import { updatePharmaorderInfo } from './PharmaorderAPI';
import { updatePharmaorderObj } from 'store/slice/PharmaSlice';
import { convertToRS } from 'core/js/FormUtils';
import { editPartyAPI } from 'api/OmsOrdermgmtWebServices';
import RefreshIcon from '@mui/icons-material/Refresh';
import { refreshOrderAPI } from 'api/OmsOrdermgmtWebServices';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';

export default function PharmaorderInfoImpl() {
  const dispatch = useDispatch();
  const navidate = useNavigate();
  const { pharmaorderObj } = useSelector((state) => state.pharmaslice.pharmaorderDashboard);
  const {partyObj } = useSelector((state) => state.pharmaslice.partyDashboard);
  const { partyList } = useSelector((state) => state.pharmaslice);

  const [selectPartyOpen, setSelectPartyOpen] = useState(false);
  const [editAdvanceOpen, setEditAdvanceOpen] = useState(false);
  const [advanceInputType, setAdvanceInputType] = useState('percentage'); // 'percentage' or 'absolute'
  const [advanceValue, setAdvanceValue] = useState('');
  const [isUpdating, setIsUpdating] = useState(false);
  const [partyFilter, setPartyFilter] = useState('');
  const [selectedPartyId, setSelectedPartyId] = useState(null);
  const [isSavingParty, setIsSavingParty] = useState(false);
  const [partySaveSuccess, setPartySaveSuccess] = useState(false);


  useEffect(()=>{

  },[pharmaorderObj])
  
  // useEffect(()=>{
  //   if (partyObj) {
  //     editPartyAPI( 
  //       { partyId: partyObj.id,
  //         orderId: pharmaorderObj.id
  //        },
  //       (apiResponse) => {
  //         dispatch(updatePharmaorderObj(apiResponse.pharmaorderInfo));
  //       },
  //       (error)=>{
  //         console.error("Error updating party in order:", error);
  //       }
  //     );
  //   }
  // },[partyObj]);

  const handleEditOrder = () => {
    dispatch(setPharmaorderEditorderModal(true));
  }
  
  const handlePoMgtm = () => {
    dispatch(setPoUploadPoModal(true));
  }
  
  const handleViewPO = () => {
    dispatch(setPoViewPOModal(true));
  }
  
  useEffect(() => {
  }, [pharmaorderObj])

  const submitOrder = () => {
    dispatch(setPharmaorderSubmitorderModal(true));
  }
  
  const getActionButton = () => {
    return "Submit for Approval";
  }
  
  const backToOrderList = () => {
    dispatch(openDrawer(true));
    navidate('/pharmaorder');
  }

  const handleEditAdvance = () => {
    // Initialize with current values
    const currentPercentage = ((pharmaorderObj.advance / pharmaorderObj.ordervalue) * 100).toFixed(2);
    setAdvanceValue(currentPercentage);
    setAdvanceInputType('percentage');
    setEditAdvanceOpen(true);
  }

  const handleAdvanceInputTypeChange = (event) => {
    const newType = event.target.value;
    setAdvanceInputType(newType);
    
    // Convert current value when switching input types
    if (newType === 'percentage') {
      const percentage = ((pharmaorderObj.advance / pharmaorderObj.ordervalue) * 100).toFixed(2);
      setAdvanceValue(percentage);
    } else {
      setAdvanceValue(pharmaorderObj.advance.toString());
    }
  }

  const handleSaveAdvance = () => {
    setIsUpdating(true);
    
    let newAdvanceValue;
    if (advanceInputType === 'percentage') {
      // Convert percentage to absolute value
      newAdvanceValue = (parseFloat(advanceValue) * pharmaorderObj.ordervalue) / 100;
    } else {
      // Use absolute value directly
      newAdvanceValue = parseFloat(advanceValue);
    }

    updatePharmaorderInfo(
      pharmaorderObj.id,
      { advance: newAdvanceValue },
      (apiResponse) => {
        dispatch(updatePharmaorderObj(apiResponse));
        setEditAdvanceOpen(false);
        setIsUpdating(false);
      },
      (error) => {
        console.error('Error updating advance:', error);
        setIsUpdating(false);
      }
    );
  }

  const calculatePreview = () => {
    if (!advanceValue || isNaN(advanceValue)) return { amount: 0, percentage: 0 };
    
    if (advanceInputType === 'percentage') {
      const amount = (parseFloat(advanceValue) * pharmaorderObj.ordervalue) / 100;
      return { amount, percentage: parseFloat(advanceValue) };
    } else {
      const percentage = (parseFloat(advanceValue) / pharmaorderObj.ordervalue) * 100;
      return { amount: parseFloat(advanceValue), percentage };
    }
  }
  const refreshOrder = () =>{
    refreshOrderAPI(
      {orderId:pharmaorderObj.id},
      (apiResponse) => {
        dispatch(updatePharmaorderObj(apiResponse.pharmaorderInfo));
      },
      (error) => {
        console.error('Error refreshing order:', error);
      }
    );
  }

  const handleSaveSelectedParty = () => {
    if (selectedPartyId) {
      setIsSavingParty(true);
      setPartySaveSuccess(false);
      // Logic to save the selected party
      editPartyAPI(
        { orderId: pharmaorderObj.id, partyId: selectedPartyId },
        (apiResponse) => {
          dispatch(updatePharmaorderObj(apiResponse.pharmaorderInfo));
          setIsSavingParty(false);
          setPartySaveSuccess(true);
          // Optionally close dialog after a delay:
          // setTimeout(() => setSelectPartyOpen(false), 1200);
        },
        (error) => {
          setIsSavingParty(false);
          setPartySaveSuccess(false);
          console.error('Error updating party:', error);
        }
      );
    }
  };

  // Reset success state if user changes selected party
  useEffect(() => {
    setPartySaveSuccess(false);
  }, [selectedPartyId]);

  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="flex-start"
      sx={{ width: '100%', backgroundColor: 'secondary.lighter', padding: 1, borderRadius: 2, }}
    >
      <Grid item lg={6} md={4} sm={4} xs={12}  sx={{}}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ width: '100%', backgroundColor: 'secondary.lighter', padding: 1, borderRadius: 2, border: '1px solid #ccc' }}
        >
          <Grid item lg={2} mg={2} xs={3}><FieldView2 label="Order Id" value={pharmaorderObj.orderid !== undefined ? pharmaorderObj.orderid : 'NOT KNONWN'} /></Grid>
          <Grid item lg={4} mg={4} xs={4}><FieldView2 label="Order Value" value={pharmaorderObj.ordervalue !== undefined ? convertToRS(pharmaorderObj.ordervalue) : 'NOT KNONWN'} /></Grid>
          <Grid item lg={5} mg={5} xs={4}><FieldView2 label="Executive Name" value={pharmaorderObj.executivename !== undefined ? pharmaorderObj.executivename : 'NOT KNONWN'} /></Grid>
          <Grid item lg={1} mg={1} xs={1}><RefreshIcon sx={{ cursor: 'pointer', ml: 1 }} onClick={refreshOrder} /></Grid>
        </Grid>
      </Grid>

      <Grid item lg={2} md={4} sm={4} xs={12} sx={{ paddingLeft: {lg:1}, md: 1, sm: 1, xs: 0, paddingTop:{xs:1, lg:0, md:0, sm:0} } }>
        <Grid container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ width: '100%',  padding: 1, borderRadius: 2, border: '1px solid #ccc', position: 'relative', minHeight: 60 }}
        >
          <Grid item lg={11} mg={11} sm={11} xs={11} sx={{backgroubdColor:'white'}}>
            <FieldView2  label={"Advance - "+((pharmaorderObj.advance/pharmaorderObj.ordervalue)*100).toFixed(2) + "%"} value={pharmaorderObj.advance !== undefined ? convertToRS(pharmaorderObj.advance) : 'NOT KNONWN'} />
          </Grid>
          <Grid 
            item 
            lg={1} mg={2} sm={2} xs={2} 
            sx={{ 
              position: 'absolute', 
              bottom: 8, 
              right: 8, 
              display: 'flex', 
              alignItems: 'flex-end', 
              justifyContent: 'flex-end',
              height: 'auto'
            }}
          >
            <ModeEditIcon sx={{ cursor: 'pointer' }} onClick={handleEditAdvance} />
          </Grid>
        </Grid>
      </Grid>

      <Grid item lg={4} md={4} sm={4} xs={12} sx={{ paddingLeft: {lg:1}, md: 1, sm: 1, xs: 0, paddingTop:{xs:1, lg:0, md:0, sm:0} } }>
        <Grid container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          sx={{ width: '100%',  padding: 1, borderRadius: 2, border: '1px solid #ccc', position: 'relative', minHeight: 60 }}
        >
          <Grid item lg={11} mg={11} sm={11} xs={11} sx={{backgroubdColor:'white'}}>
            <FieldView2  label="Party Name" value={pharmaorderObj.partyname !== undefined ? pharmaorderObj.partyname : 'NOT KNONWN'} />
          </Grid>
          <Grid 
            item 
            lg={1} mg={2} sm={2} xs={2} 
            sx={{ 
              position: 'absolute', 
              bottom: 8, 
              right: 8, 
              display: 'flex', 
              alignItems: 'flex-end', 
              justifyContent: 'flex-end',
              height: 'auto'
            }}
          >
            <ModeEditIcon sx={{ cursor: 'pointer' }} onClick={() => setSelectPartyOpen(true)} />
          </Grid>
        </Grid>
      </Grid>

      {/* Edit Advance Dialog */}
      <Dialog
        open={editAdvanceOpen}
        onClose={() => setEditAdvanceOpen(false)}
        maxWidth="md"
        
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 0 }}>
          Edit Advance
          <Button
            onClick={() => setEditAdvanceOpen(false)}
            sx={{ minWidth: 0, color: "grey.700" }}
            aria-label="Close"
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2 }}>
            <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary', backgroundColor:'secondary.100', p:2, borderRadius: 1 }}>
              Current Advance: {convertToRS(pharmaorderObj.advance)} ({((pharmaorderObj.advance/pharmaorderObj.ordervalue)*100).toFixed(2)}%)
            </Typography>
            
            <Grid container spacing={3} sx={{ mt: 1 }}>
              {/* Left Column - Input Type */}
              <Grid item xs={12} md={6}>
                <FormControl component="fieldset">
                  <FormLabel component="legend" sx={{ mb: 2 }}>Input Type</FormLabel>
                  <RadioGroup
                    value={advanceInputType}
                    onChange={handleAdvanceInputTypeChange}
                  >
                    <FormControlLabel value="percentage" control={<Radio />} label="Percentage (%)" />
                    <FormControlLabel value="absolute" control={<Radio />} label="Absolute Value (₹)" />
                  </RadioGroup>
                </FormControl>
              </Grid>

              {/* Right Column - Text Box and Preview */}
              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label={advanceInputType === 'percentage' ? 'Advance Percentage' : 'Advance Amount'}
                  type="number"
                  value={advanceValue}
                  onChange={(e) => setAdvanceValue(e.target.value)}
                  InputProps={{
                    endAdornment: advanceInputType === 'percentage' ? '%' : '₹'
                  }}
                  sx={{ mb: 2 }}
                />

                {advanceValue && !isNaN(advanceValue) && (
                  <Box sx={{ p: 2, backgroundColor: 'info.lighter', borderRadius: 1 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>Preview:</Typography>
                    <Typography variant="body2">
                      Amount: {convertToRS(calculatePreview().amount)}
                    </Typography>
                    <Typography variant="body2">
                      Percentage: {calculatePreview().percentage.toFixed(2)}%
                    </Typography>
                  </Box>
                )}
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setEditAdvanceOpen(false)}>Cancel</Button>
          <Button 
            onClick={handleSaveAdvance} 
            variant="contained"
            disabled={!advanceValue || isNaN(advanceValue) || isUpdating}
          >
            {isUpdating ? 'Saving...' : 'Save'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* SelectParty Dialog */}
      <Dialog
        open={selectPartyOpen}
        onClose={() => setSelectPartyOpen(false)}
        maxWidth={false}
        fullWidth
        PaperProps={{
          sx: {
            width: '70vw',
            maxWidth: '70vw',
            m: 0
          }
        }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 0 }}>
          Select Party
          <Button
            onClick={() => setSelectPartyOpen(false)}
            sx={{ minWidth: 0, color: "grey.700" }}
            aria-label="Close"
          >
            <CloseIcon />
          </Button>
        </DialogTitle>
        <DialogContent>
          {/* Existing Party Box */}
          <Box sx={{ backgroundColor: 'secondary.100', borderRadius: 1, p: 2, mb: 2 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>Current Party</Typography>
            <Typography variant="body1" sx={{ fontWeight: 600 }}>
              {pharmaorderObj.partyname || "No Party Selected"}
            </Typography>
          </Box>

          {/* Party Selection List with Filter */}
          <Box sx={{  borderRadius: 1, p: 2, mb: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1 }}>
              <Typography variant="h5">Select New Party</Typography>
              <TextField
                label="Filter by Party Name"
                value={partyFilter || ""}
                onChange={e => setPartyFilter(e.target.value)}
                size="small"
                sx={{ width: 300 }}
              />
            </Box>
            <Box
              sx={{
                maxHeight: '40vh',
                overflowY: 'auto',
                width: '100%',
                pr: 1
              }}
            >
              <Grid container spacing={2}>
                {partyList
                  .filter(party =>
                    party.title.toLowerCase().includes((partyFilter || "").toLowerCase())
                  )
                  .map((party, idx) => (
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      md={4}
                      lg={3}
                      key={party.id}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          backgroundColor: selectedPartyId == party.id ? 'primary.lighter' : 'white',
                          borderRadius: 1,
                          p: 1,
                          border: selectedPartyId == party.id ? '2px solid' : '1px solid #eee',
                          borderColor: selectedPartyId == party.id ? 'primary.main' : '#eee',
                          cursor: 'pointer'
                        }}
                        onClick={() => setSelectedPartyId(party.id)}
                      >
                        <Radio
                          checked={selectedPartyId == party.id}
                          value={party.id}
                          onChange={() => setSelectedPartyId(party.id)}
                          sx={{ mr: 1 }}
                        />
                        <Typography variant="body2">{party.title}</Typography>
                      </Box>
                    </Grid>
                  ))}
              </Grid>
            </Box>
          </Box>

          {/* Save Button */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, minHeight: 40 }}>
            {isSavingParty ? (
              <CircularProgress size={28} />
            ) : partySaveSuccess ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <CheckCircleIcon color="success" />
                <Typography color="success.main">Saved!</Typography>
              </Box>
            ) : (
              <Button
                variant="contained"
                disabled={!selectedPartyId}
                onClick={handleSaveSelectedParty}
              >
                Save
              </Button>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </Grid>
  )
}